/**
 * ロゴのインライン SVG — **「kalori」を文字で組まないための共通の入口**。
 *
 * パスの正は `assets/logo-green.svg`（`npm run brand:gen` が `paths.generated.ts` へ写す）。
 * `<img src="/SVG/green.svg">` を置ける面（kalori.jp）はそちらを使う。ここは置けない面のため:
 * 別オリジン（my.kalori.jp・brands / coaches / console / admin / mcp）、`img-src` を絞った CSP、
 * canvas（`Path2D`）。
 *
 * ⚠️ 原本の SVG をそのまま埋めない — `<defs><style>.cls-1{…}</style></defs>` を持つので、
 * ページ全体の `.cls-1` に効く上に、nonce / `'self'` の `style-src` では止められる。
 * ここは `fill` 属性だけで描く（属性は CSP の style に当たらない）。
 */
import { LOGO_GREEN, LOGO_PATHS, LOGO_VIEWBOX_HEIGHT, LOGO_VIEWBOX_WIDTH } from "./paths.generated.js";
export { LOGO_GREEN, LOGO_PATHS, LOGO_VIEWBOX_HEIGHT, LOGO_VIEWBOX_WIDTH };
export const LOGO_VIEWBOX = `0 0 ${LOGO_VIEWBOX_WIDTH} ${LOGO_VIEWBOX_HEIGHT}`;
/** 高さ（px）からロゴの幅を求める（縦横比は原本のまま）。 */
export function logoWidth(height) {
    return Math.round((height * LOGO_VIEWBOX_WIDTH) / LOGO_VIEWBOX_HEIGHT * 100) / 100;
}
/** HTML 文字列としてのロゴ（Workers が組む HTML 用）。 */
export function logoSvg({ height, fill = "currentColor", label = "kalori", className }) {
    const a11y = label === null ? ' aria-hidden="true"' : ` role="img" aria-label="${escapeAttr(label)}"`;
    const cls = className ? ` class="${escapeAttr(className)}"` : "";
    const paths = LOGO_PATHS.map((d) => `<path d="${d}"/>`).join("");
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${LOGO_VIEWBOX}" width="${logoWidth(height)}" height="${height}" fill="${escapeAttr(fill)}"${cls}${a11y} focusable="false">${paths}</svg>`;
}
function escapeAttr(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
}
//# sourceMappingURL=index.js.map